// extracted by mini-css-extract-plugin
module.exports = {"section-divider":"section-divider_section-divider__3AP4Q"};